export const Role = {
    Manager: 'Manager',
    Admin:"Admin",
    Test: 'dtest',

}